import { doGet, doPost } from "./BaseAPI";

export function getLanguages() {
  return doGet(`/organization/language`);
}

export function updateLanguages(domain, languages) {
  return doPost("/organization/language", {domain: domain, language: languages});
}
